var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{staticClass:"mt-4"},_vm._l((_vm.sections),function(section){return _c('div',{key:section.id},[_c('b-row',[_c('p',{staticStyle:{"text-align":"left"},domProps:{"innerHTML":_vm._s(section.content)}})])],1)}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }